import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import { ComponentsRoutingModule } from "./components-routing.module";
import { PopupComponent } from "./popup/popup.component";
import { GeneralComponent } from "./general/general.component";
import { QuestionsComponent } from "./questions/questions.component";
import { SharedModule } from "../shared/shared.module";
import { FormsModule } from "@angular/forms";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { AutocompleteComponent } from "./autocomplete/autocomplete.component";
import { NumberDirective } from "../Directives/numbers-only.directive";
import { CeaSliderComponent } from "./cea-slider/cea-slider.component";
import { CeaHelpButtonComponent } from './cea-help-button/cea-help-button.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CeaRadioGroupComponent } from "./cea-radio-group/cea-radio-group.component";
import { PolicyDiffComponent } from './policy-diff/policy-diff.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { GoogleAutoCompleteDirective } from '../Directives/google-auto-complete.directive';
import { TrackVisibilityDirective } from '../Directives/track-visibility.directive';
import { CeaPlaceholderPipe } from "../shared/pipes/cea-placeholder/cea-placeholder.pipe";
import { AddressComponent } from "./address/address.component";
import { ProductSpotlightComponent } from "./product-spotlight/product-spotlight.component";
import { HeaderTranslatorComponent } from "./header-translator/header-translator.component";
import { PremiumSpotlightComponent } from "./premium-spotlight/premium-spotlight.component";
import { NgxGaugeModule } from "ngx-gauge";
import { CeaSliderBootstrapComponent } from "./cea-slider-bootstrap/cea-slider-bootstrap.component";
import { CeaRadioGroupBootstrapComponent } from "./cea-radio-group-bootstrap/cea-radio-group-bootstrap.component";

@NgModule({
    declarations: [PopupComponent,
        GeneralComponent,
        QuestionsComponent,
        ProductSpotlightComponent,
        PremiumSpotlightComponent,
        AutocompleteComponent,
        NumberDirective,
        CeaSliderComponent,
        CeaSliderBootstrapComponent,
        CeaRadioGroupBootstrapComponent,
        CeaRadioGroupComponent,
        CeaHelpButtonComponent,
        HeaderTranslatorComponent,
        PolicyDiffComponent,
        ConfirmComponent,
        GoogleAutoCompleteDirective,
        TrackVisibilityDirective,
        CeaPlaceholderPipe,
        AddressComponent],
    exports: [
        GeneralComponent,
        QuestionsComponent,
        ProductSpotlightComponent,
        PremiumSpotlightComponent,
        PopupComponent,
        CeaSliderComponent,
        CeaSliderBootstrapComponent,
        CeaRadioGroupBootstrapComponent,
        CeaRadioGroupComponent,
        CeaHelpButtonComponent,
        HeaderTranslatorComponent,
        PolicyDiffComponent
    ],
    imports: [
    CommonModule,
    ComponentsRoutingModule,
    SharedModule,
    FormsModule,
    NgbDatepickerModule,
    NgxSliderModule,
    NgxGaugeModule
]
})
export class ComponentsModule {
}
